
import SortingVisualizer from "./SortingVisualizer/SortingVisualizer";
import "./App.css";

function App() {
  return (
    <div className="App">
      <SortingVisualizer />
    </div>
  );
}

export default App;
